import { createFileRoute } from "@tanstack/react-router";
import RequestEstimate from "@/pages/RequestEstimate";
import { requestEstimateHead } from "@/lib/route-seo";

export const Route = createFileRoute("/request-estimate")({
  head: () => requestEstimateHead(),
  component: RequestEstimate,
});
